<form [formGroup]="serviceForm" id="add-modify-service-config">
    <div class="col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Service Name</mat-label>
            <input matInput id="serviceName" type="text" maxlength="50"
                (paste)="on_paste_omit_special_char($event,'serviceName', [32, 45, 95])"
                (keypress)="omit_special_char($event, true, [32, 45, 95])" (blur)="validateServiceName()"
                formControlName="serviceName" required [readonly]="IsReadOnly" aria-label="serviceName"
                aria-labelledby="my-label-id" aria-controls="my-helper-id" aria-describedby="my-helper-id">
            <mat-icon mat-icon-button matSuffix matTooltip="{{configserviceNameInfoMsg}}"
              aria-hidden="true"  matTooltipClass="ey-custom-tooltip"
                matTooltipPosition="above">info</mat-icon>
        </mat-form-field>
    </div>
   
    <div class="col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>GitHub Repository Name</mat-label>
            <input matInput id="gitHubRepositoryName" type="text" maxlength="256"
                (paste)="on_paste_omit_special_char($event,'gitHubRepositoryName', [45, 95])"
                (keypress)="omit_special_char($event, true, [45, 95])" formControlName="gitHubRepositoryName" required
                [readonly]="IsReadOnly" (blur)="validateGitHubRepositoryName()" aria-label="gitHubRepositoryId"
                aria-labelledby="my-label-id" aria-controls="my-helper-id" aria-describedby="my-helper-id">
            <mat-icon mat-icon-button matSuffix matTooltip="{{configGitRepoNameInfoMsg}}"
             aria-hidden="true"  matTooltipClass="ey-custom-tooltip"
                matTooltipPosition="above">info</mat-icon>
        </mat-form-field>
    </div>
    <div class="col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>GitHub Repository Default Branch</mat-label>
            <input matInput id="gitHubDefaultBranchName" type="text" maxlength="100" formControlName="gitHubDefaultBranchName" required
                [readonly]="IsReadOnly" aria-label="gitHubDefaultBranchName" aria-labelledby="my-label-id"
                aria-controls="my-helper-id" aria-describedby="my-helper-id">
            <mat-icon style="font-size: 18px; height:20px;" mat-icon-button matSuffix matTooltip="{{configgitHubDefaultBranchNameInfoMsg}}"
                 aria-hidden="true"  matTooltipClass="ey-custom-tooltip"
            matTooltipPosition="above">info</mat-icon>
        </mat-form-field>
    </div>
    <div class="col-sm-12">
        <div class="form-row-flex">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Components</mat-label>
                <mat-select id="configuration"
                    formControlName="configuration"
                    required
                    [multiple]="true"
                    (selectionChange)="OnConfigurationChange()">
                    <mat-option *ngFor="let config of availableConfigurations" [value]="config"
                      [disabled]="this.data && this.data.hasAPI && config === 'API' || this.data && this.data.hasWeb && config === 'Web'">
                      {{ config }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-icon  aria-hidden="true"  matTooltipClass="ey-custom-tooltip" matTooltip="If the component(API or Web) is already linked to a release, it can not be unmapped." class="info-icon">info</mat-icon>
        </div>
    </div>

    <div class="col-sm-12">
<mat-form-field appearance="fill" class="w-100">
  <mat-label>Status</mat-label>
    <mat-select id="status"
        formControlName="status"
        panelClass="configuration-select-panel"
        required>
        <mat-option [value]="1">
            <span style="flex:1">Active</span>
            <mat-icon matTooltipClass="ey-custom-tooltip" matTooltip="Any service can be set to Active." style="margin-left:8px; vertical-align: middle; height: auto; width: auto;">info</mat-icon>
        </mat-option> 
        <mat-option *ngIf="!isServiceReleaseExists" [value]="0">
            <span>Inactive</span>
            <span style="flex:1"></span>
            <mat-icon matTooltipClass="ey-custom-tooltip" matTooltip="This option is only allowed if the service is not mapped to any environments." style="margin-left:8px; vertical-align: middle;height: auto; width: auto;">info</mat-icon>
        </mat-option>
        <mat-option *ngIf="isServiceReleaseExists && this.data" [value]="2">
            <span>Inactive For Future Release</span>
            <span style="flex:1"></span>
            <mat-icon matTooltipClass="ey-custom-tooltip" matTooltip="This status is supported only for existing releases and should be hidden for future releases." style="margin-left:8px; vertical-align: middle;height: auto; width: auto;">info</mat-icon>
        </mat-option>
  </mat-select>
</mat-form-field>
    </div>
   
        <div class="row m-t-10 m-b-10">
        <div class="gap"></div>
        
        <div class="col-sm-4">
            
        </div>

    </div>
    
    <div class="col-sm-12 m-b-10">
        <div class="row m-r-0 m-l-0">
            <div class="col pl-0 text-right">
                <button class="mdc-button ripple-material" (click)="close()" type="button">
                    <span class="mdc-button__ripple"></span> Cancel
                </button>
                <button class="mdc-button ml-3 fids-tooltip mdc-button--raised mdc-button--sharp ripple-material"
                    [disabled]="!serviceForm.valid" (click)="save()" type="submit" #submitButton>
                    <span class="mdc-button__ripple"></span> Submit
                </button>
            </div>
        </div>
    </div>
</form>
